import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Col, Row } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroll-component';

import {I18n} from '../../I18n/components/companyMarketAppList';
import { API_BASE_URL } from '../../helpers/constants';

import './companyMarketAppList.css';
import noImg from '../../assets/images/img-error.svg';

class CompanyMarketAppList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			apps: [],
			hasMore: true,
			page:0,
			totalElements: false,
			height: 300,
			loading: false
		}
	}

	componentDidMount () {
        window.addEventListener("load", this.updateDimensions);
        window.addEventListener("resize", this.updateDimensions);
		(async () => {
            await this.updateDimensions();
            await this.setState({
				loading: true
			});
			const result = await this.props.getApps(this.state.page);
			this.setState(state => ({
				apps: result && result.data ? result.data : [],
				page: state.page + 1,
					totalElements: result && result.totalElements ? result.totalElements : 0,
				hasMore: result && result.data ? result.data.length !== 0 : false,
				loading: false
			}));
		})();
	}

	componentDidUpdate(prevProps) {
		if (this.props.filter !== prevProps.filter ||
            this.props.id !== prevProps.id ||
            this.props.hasUpdates !== prevProps.hasUpdates
        ) {
			this.setState({
				loading: true
			}, async () => {
				const result = await this.props.getApps(0);
				this.setState({
					apps: result && result.data ? result.data : [],
					page: 1,
					totalElements: result && result.totalElements ? result.totalElements : 0,
					hasMore: result && result.data ? result.data.length !== 0 : false,
					loading: false
				}, () => this.updateDimensions());
			});
		}
	}

    componentWillUnmount() {
        window.removeEventListener("load", this.updateDimensions);
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions = async () => {
		let width = window.innerWidth;
		let height = 300;

        if (width < 767) {
            height = 300;
        } else if (width < 1170) {
            height = 450;
        } else {
        	height = 650;
		}

        await this.setState({
            height
        });
    };

	fetchMoreData = async () => {
		const result = await this.props.getApps(this.state.page);
		const newApps = [...this.state.apps];
		result.data.forEach(app => {
			const index = newApps.findIndex((elem) => elem.mobileAppId === app.mobileAppId);
			if (index === -1) {
				newApps.push(app);
			} else {
				newApps[index] = app;
			}
		});

		this.setState(state => ({
			apps: newApps,
			hasMore: state.apps.length < newApps.length,
			page: state.page + 1
		}), ()=> {
		});
	};

	render() {
	    console.log('render app list')
		let appList = [];
		if (this.state.loading) {
			return <div>Loading...</div>
		}
		if (!this.state.apps.length && !this.state.loading) {
			appList = <div className="divider-block">
				<b>{I18n[this.props.lang].noMore} </b>
			</div>
		} else {
			appList = this.state.apps.map(item => {
				let versionApk = null;
				let isRequiredForInstall = null;
                let isMarketing = null;
				try {
					const aktiveApk = item.mobileApp.apks.filter(apk => apk.id === item.checkedApkIds[0])[0] ||
						item.mobileApp.apks.filter(apk => apk.id === item.marketingApks[0].marketingApkId)[0];
					const selectedAttr =  item.mobileApp.mobileAppAttributes.filter(attr => attr.attribute.label === 'APKRequiredForInstall')[0];
					isMarketing = item.marketingApks && item.marketingApks.length;
					if (aktiveApk && aktiveApk.attributes.length) {
						const activeAttribute = aktiveApk.attributes.filter(attr => attr.attribute && attr.attribute.name === 'versionName')[0];
						if (activeAttribute) {
							versionApk = activeAttribute.value;
						}
					}
					if (selectedAttr) {
						isRequiredForInstall = selectedAttr.value == 'true';
					}
				} catch (err)  {
					console.log(err)
				}
				return (
					<div
						title={versionApk ? versionApk : 'none'}
						className="market-app-list__app"
						key={item.mobileApp.id}
						onClick={event => {
							event.stopPropagation();
							this.props.showApp(this.state.apps, item.mobileApp.id);
						}}
					>
						<span className={isRequiredForInstall ?
							"market-app-list__required market-app-list__required--show" : "market-app-list__required"}
							  title={I18n[this.props.lang].required}
						></span>
						<span className={item.hasUpdates ?
							"market-app-list__updated market-app-list__updated--show" : "market-app-list__updated"}
							  title={I18n[this.props.lang].updated}
						><i className="mdi mdi-arrow-up-bold"></i></span>
						<span className={isMarketing ?
							"market-app-list__commerce market-app-list__commerce--show" : "market-app-list__commerce"}
							  title={I18n[this.props.lang].commerce}
						><i className="mdi mdi-currency-usd"></i></span>
						<img
							src={`${API_BASE_URL}/apps/mobileapps/download/icon/${item.mobileApp.id}`}
							alt="application logotype"
							className="img-fluid media-object"
							width="40"
							onError={(e) => {
								e.target.onerror = null;
								e.target.src = noImg
							}}
						/>
						<span className="market-app-list__text">{item.mobileApp.appLabel}</span>
						<span className="market-app-list__version">{versionApk ? versionApk : 'none'}</span>
					</div>
				)
			})
		}
		return (
			<Row>
				<Col sm="12" lg="12" id={this.props.id} style={{ overflow: "auto" }}>
						<InfiniteScroll
							className="market-app-list__content"
							dataLength={this.state.apps.length || 0}
							next={this.fetchMoreData}
							hasMore={this.state.hasMore}
							loader={<div className="divider-block">Loading...</div>}
							height={0}
							//style={{"maxHeight": `${this.state.height}px`}}
							scrollThreshold={0.1}
							endMessage={
								<div className="divider-block">
									{/*<b>--- No more Items --- </b>*/}
								</div>
							}
						>
							{appList}
						</InfiniteScroll>
				</Col>
			</Row>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
	};
};

const mapStateToProps = state => ({
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyMarketAppList)



// WEBPACK FOOTER //
// ./src/components/CompanyMarketAppList/CompanyMarketAppList.js